module.exports = __webpack_public_path__ + "/99969c0d43972a84c830e25ba0e06eda.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/landing-pages/assets/screenshot_gmail.png
 ** module id = 1646
 ** module chunks = 0
 **/